import { useFormikContext } from "formik"
import { useDEFormContext } from "../context/DEFormContext"


const StatusSection = () => {
    const formik = useFormikContext()
    const { appealOutcomeOptions, punishmentSecondaryOption, punishmentSecondaryTypeOption, defaultPunishment } = useDEFormContext()

    return (
        <>
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">Outcome of appeal/Review</label>
                <div className="col-sm-8">
                    <select
                        className="form-control"
                        name="deAppealOutcome"
                        value={formik.values.deAppealOutcome}
                        onChange={formik.handleChange}
                    >
                        <option value="">Select</option>
                        {appealOutcomeOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    {formik.touched.deAppealOutcome &&
                        formik.errors.deAppealOutcome && (
                            <div className="invalid-feedback d-block">
                                {formik.errors.deAppealOutcome}
                            </div>
                        )}
                </div>
            </div>
            
            
            {
                ['partially', 'punishmentEnhanced'].includes(formik.values.deAppealOutcome)
                && (
                    <>
                        <div hidden className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label">Punishment Type</label>
                            <div className="col-sm-8">
                                <select
                                    className="form-control"
                                    name="dePunishmentSecondaryType"
                                    value={formik.values.dePunishmentSecondaryType}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">Select Punishment Type </option>
                                    {punishmentSecondaryTypeOption?.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.name}
                                        </option>
                                    ))}
                                </select>
                                {formik.touched.dePunishmentSecondaryType && formik.errors.dePunishmentSecondaryType && (
                                    <div className="invalid-feedback d-block">
                                        {formik.errors.dePunishmentSecondaryType}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label">Punishment</label>
                            <div className="col-sm-8">
                                <select
                                    className="form-control"
                                    name="dePunishmentSecondary"
                                    value={formik.values.dePunishmentSecondary}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">Select Punishment </option>
                                    {punishmentSecondaryOption?.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.name}
                                        </option>
                                    ))}
                                </select>
                                {formik.touched.dePunishmentSecondary &&
                                    formik.errors.dePunishmentSecondary && (
                                        <div className="invalid-feedback d-block">
                                            {formik.errors.dePunishmentSecondary}
                                        </div>
                                    )}
                            </div>
                        </div>
                        <div className="form-group row mb-3">
                    <label className="col-sm-4 col-form-label">Date Of Decision Of Appeal/Review</label>
                    <div className="col-sm-8">
                      <input
                        type="date"
                        className="form-control"
                        name="deDateDecisionAppeal"
                        value={formik.values.deDateDecisionAppeal}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    />
                      {formik.touched.deDateDecisionAppeal &&
                        formik.errors.deDateDecisionAppeal && (
                          <div className="invalid-feedback d-block">
                            {formik.errors.deDateDecisionAppeal}
                          </div>
                        )}
                    </div>
                  </div>

                        {Object.values(defaultPunishment).includes(
                            formik.values.dePunishmentSecondary
                        ) && (
                                <>
                                    <div className="form-group row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                            No. of increment stopped
                                        </label>
                                        <div className="col-sm-8">
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="annualStoppageSecondary"
                                                value={formik.values.annualStoppageSecondary}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.annualStoppageSecondary &&
                                                formik.errors.annualStoppageSecondary && (
                                                    <div className="invalid-feedback d-block">
                                                        {formik.errors.annualStoppageSecondary}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </>
                            )}
                    </>
                )
            }

        </>
    )
}

export default StatusSection